(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["google-translate"] && !Shopify.designMode) return;
  try {
    (function() {
    let googleTranslateInstances = [];
    let isGoogleTranslateLoaded = false;
    
    // Global callback for Google Translate initialization
    window.googleTranslateElementInit = function() {
      if (document.getElementById('google_translate_element')) {
        new google.translate.TranslateElement({
          pageLanguage: 'en',
          includedLanguages: '', // Empty string includes all languages
          layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: false
        }, 'google_translate_element');
        
        isGoogleTranslateLoaded = true;
        
        // Wait a moment for the widget to fully initialize
        setTimeout(() => {
          googleTranslateInstances.forEach(instance => instance.onGoogleTranslateReady());
        }, 500);
      }
    };
    
    class GoogleTranslate {
      constructor(element) {
        this.element = element;
        this.button = element.querySelector('.google-translate__button');
        this.dropdown = element.querySelector('.google-translate__dropdown');
        this.list = element.querySelector('.google-translate__list');
        this.items = element.querySelectorAll('.google-translate__item');
        this.ready = false;
        this.isOpen = false;
        
        googleTranslateInstances.push(this);
        this.init();
      }
      
      init() {
        // Bind button click to toggle dropdown
        this.button.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleDropdown();
        });
        
        // Bind click event to each language item
        this.items.forEach((item) => {
          item.addEventListener('click', (e) => {
            e.stopPropagation();
            this.handleLanguageSelect(item);
            this.closeDropdown();
          });
        });
        
        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
          if (this.isOpen && !this.element.contains(e.target)) {
            this.closeDropdown();
          }
        });
        
        // Close on escape key
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.isOpen) {
            this.closeDropdown();
          }
        });
        
        // Restore selection from storage
        this.restoreSelection();
        
        // Load Google Translate script if not already loaded
        if (!document.querySelector('script[src*="translate.google.com"]')) {
          const script = document.createElement('script');
          script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
          script.async = true;
          document.head.appendChild(script);
        } else if (isGoogleTranslateLoaded) {
          // Script already loaded
          setTimeout(() => this.onGoogleTranslateReady(), 500);
        }
      }
      
      toggleDropdown() {
        if (this.isOpen) {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }
      }
      
      openDropdown() {
        this.dropdown.removeAttribute('hidden');
        this.button.setAttribute('aria-expanded', 'true');
        this.isOpen = true;
        
        // Set data-menu-active on header to keep it filled when transparent
        document.querySelector('.header')?.setAttribute('data-menu-active', '');
      }
      
      closeDropdown() {
        this.dropdown.setAttribute('hidden', '');
        this.button.setAttribute('aria-expanded', 'false');
        this.isOpen = false;
        
        // Remove data-menu-active from header
        document.querySelector('.header')?.removeAttribute('data-menu-active');
      }
      
      onGoogleTranslateReady() {
        this.ready = true;
        console.log('Google Translate ready');
      }
      
      handleLanguageSelect(item) {
        const language = item.getAttribute('data-lang');
        
        // Remove active class from all items
        this.items.forEach(i => i.classList.remove('active'));
        
        // Add active class to selected item
        item.classList.add('active');
        
        if (!language) {
          // Reset to original language
          this.resetTranslation();
          return;
        }
        
        console.log('Changing language to:', language);
        
        // Delete any existing googtrans cookies first
        this.deleteCookie('googtrans');
        this.deleteCookie('googtrans', '/');
        
        // Set the cookie directly - this is the most reliable method
        this.setCookie('googtrans', `/en/${language}`, 1);
        
        // Immediately reload page to apply translation
        // This is the most reliable way to trigger Google Translate
        window.location.reload();
      }
      
      resetTranslation() {
        // Remove all Google Translate cookies
        this.deleteCookie('googtrans');
        this.deleteCookie('googtrans', '/' );
        
        // Reload page to reset translation
        window.location.reload();
      }
      
      restoreSelection() {
        // Check cookie for saved language
        const cookie = this.getCookie('googtrans');
        
        if (cookie) {
          const langCode = cookie.split('/')[2];
          if (langCode) {
            // Find and mark the active language item
            this.items.forEach(item => {
              if (item.getAttribute('data-lang') === langCode) {
                item.classList.add('active');
              }
            });
          }
        } else {
          // No cookie, mark English as active
          this.items.forEach(item => {
            if (item.getAttribute('data-lang') === '') {
              item.classList.add('active');
            }
          });
        }
      }
      
      // Cookie utilities
      setCookie(name, value, days) {
        let expires = '';
        if (days) {
          const date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + value + expires + '; path=/';
      }
      
      getCookie(name) {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) === ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      }
      
      deleteCookie(name, path = '/') {
        // Get the domain - use parent domain if subdomain exists
        const hostname = window.location.hostname;
        const parts = hostname.split('.');
        const domain = parts.length > 2 ? '.' + parts.slice(-2).join('.') : hostname;
        
        // Delete with current domain
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=' + path + ';';
        
        // Delete with domain attribute for parent domain cookies
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=' + path + '; domain=' + domain;
      }
    }
    
    // Initialize all Google Translate widgets
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWidgets);
    } else {
      initWidgets();
    }
    
    function initWidgets() {
      document.querySelectorAll('[data-google-translate]').forEach((element) => {
        new GoogleTranslate(element);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-overlay"] && !Shopify.designMode) return;
  try {
    // Hide the image overlay(s) while the Fibbl 3D/AR viewer is active, and show them again once  switched back to the regular product photo.
  
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-element="fibbl-model-viewer"]')) {
      document.querySelectorAll('.image-overlay').forEach((overlay) => {
        overlay.classList.add('image-overlay--viewing-3d');
      });
    } else if (event.target.closest('[data-element="default"]')) {
      document.querySelectorAll('.image-overlay').forEach((overlay) => {
        overlay.classList.remove('image-overlay--viewing-3d');
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slideshow-controls"] && !Shopify.designMode) return;
  try {
    class SlideshowControls extends HTMLElement {
    connectedCallback() {
      this.thumbnailsWrapper = this.querySelector('.slideshow-controls__thumbnails');

      /////////// Fibbl Script Start ///////////
      const gallery = this.closest('media-gallery');
      if (!this.closest('quick-add-dialog') && gallery) {
        const thumbnails = this.querySelectorAll('.slideshow-controls__thumbnail');
        const firstThumbnail = thumbnails[0];
        const fibbl3DButton = gallery.querySelector('[data-element="fibbl-model-viewer"]');
        const fibblDefaultButton = gallery.querySelector('[data-element="default"]');

        firstThumbnail?.classList.remove('fibbl-3d-thumb');
        const fibblLayer = gallery.querySelector('fibbl-layer');
        const fibblProductId = fibblLayer?.getAttribute('data-product-id');
        let fibblAttempts = 0;
        const fibblReady = setInterval(async () => {
          fibblAttempts += 1;
          if (fibblAttempts > 5 || (typeof Fibbl !== 'undefined' && Fibbl.checkModelAvailability && fibblProductId)) {
            clearInterval(fibblReady);
          }
          if (typeof Fibbl !== 'undefined' && Fibbl.checkModelAvailability && fibblProductId) {
            const hasFibbl = await Fibbl.checkModelAvailability(fibblProductId);
            if (hasFibbl && firstThumbnail) {
              firstThumbnail.classList.add('fibbl-3d-thumb');
            }
            thumbnails.forEach((thumbnail, index) => {
              thumbnail.addEventListener('click', () => {
                if (index === 0 && hasFibbl) {
                  fibbl3DButton?.click();
                } else {
                  fibblDefaultButton?.click();
                }
              });
            });
          }
        }, 300);
      }
/////////// Fibbl Script End ///////////
      
      // Set up arrow button event listeners
      const prevArrow = this.querySelector('[ref="thumbnailPrevArrow"]');
      const nextArrow = this.querySelector('[ref="thumbnailNextArrow"]');
      
      if (prevArrow) {
        prevArrow.addEventListener('click', () => {
          this.navigateThumbnail(-1);
        });
      }
      
      if (nextArrow) {
        nextArrow.addEventListener('click', () => {
          this.navigateThumbnail(1);
        });
      }
    }

    navigateThumbnail(direction) {
      if (!this.thumbnailsWrapper) return;

      const thumbnails = this.thumbnailsWrapper.querySelectorAll('.slideshow-controls__thumbnail');
      if (thumbnails.length === 0) return;

      // Find the currently selected thumbnail
      const currentIndex = Array.from(thumbnails).findIndex(
        thumb => thumb.getAttribute('aria-selected') === 'true'
      );

      if (currentIndex === -1) return;

      // Calculate next index with wrapping
      let nextIndex = currentIndex + direction;
      if (nextIndex < 0) nextIndex = thumbnails.length - 1;
      if (nextIndex >= thumbnails.length) nextIndex = 0;

      // Click the next thumbnail to trigger selection
      thumbnails[nextIndex].click();
    }
  }

  if (!customElements.get('slideshow-controls')) {
    customElements.define('slideshow-controls', SlideshowControls);
  }
  } catch(e) { console.error(e); }
})();

})();
